import { AuthenticationLevel } from 'auth';
import { TAGS_HIERARCHY_PATH } from 'apps/navigation/constants';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';
import { requiredLoginLevel } from 'utils/routes/requiredLoginLevel';

import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';

import betaFeatures from './betaFeatures';

export default [
  {
    path: 'coupons',
    indexRoute: {
      onEnterHandlers: [
        requiredLoginLevel(AuthenticationLevel.REMEMBERED),
        verifyRequiredBetaFeatures([betaFeatures.COUPONS20_PAGE]),
      ],
      getComponent(location, callback) {
        import(/* webpackChunkName: "coupons" */ './containers/CouponsPage')
          .then(component => callback(null, component.default));
      },
      gtmPageType: gtmPageTypes.Coupons,
      layoutSidebarLeft: true,
      couponLinkOnFops: true,
    },
    childRoutes: [
      {
        onEnterHandlers: [
          requiredLoginLevel(AuthenticationLevel.REMEMBERED),
          verifyRequiredBetaFeatures([betaFeatures.COUPONS20_PAGE]),
        ],
        childRoutes: [
          {
            path: 'products',
            getComponent(location, callback) {
              import(/* webpackChunkName: "couponsCampaign" */ './containers/CouponsCampaignPage')
                .then(component => callback(null, component.default));
            },
            gtmPageType: gtmPageTypes.Coupons,
            layoutSidebarLeft: true,
          },
          {
            path: `products${TAGS_HIERARCHY_PATH}`,
            getComponent(location, callback) {
              import(/* webpackChunkName: "couponsCampaign" */ './containers/CouponsCampaignPage')
                .then(component => callback(null, component.default));
            },
            gtmPageType: gtmPageTypes.Coupons,
            layoutSidebarLeft: true,
          },
        ],
      },
    ],
  },
  {
    path: `coupons${TAGS_HIERARCHY_PATH}`,
    onEnterHandlers: [
      requiredLoginLevel(AuthenticationLevel.REMEMBERED),
      verifyRequiredBetaFeatures([betaFeatures.COUPONS20_PAGE]),
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "couponsCampaign" */ './containers/CouponsPage')
        .then(component => callback(null, component.default));
    },
    gtmPageType: gtmPageTypes.Coupons,
    layoutSidebarLeft: true,
    couponLinkOnFops: true,
  },
];
